import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

/**
 * Variant layout for AccommodationPackageTile with new column structure:
 * - Merges cancellation policy with inclusions in left column
 * - Moves pricing to independent right column
 * - Adjusts column widths
 */
const AccommodationPackageTileGrid = styled.div`
  display: grid;
  column-gap: ${rem(32)};
  grid-template-columns: 4fr 3fr;
  grid-template-areas: "pricing cta";
`

function AccommodationPackageTileColumnsVariant(props: PropsWithChildren) {
  return <AccommodationPackageTileGrid {...props} />
}

export default AccommodationPackageTileColumnsVariant
